import { NodeType } from './node-type.model';
import { Node } from './node.model';

export interface TreeNode {
	name: string;
	id: number;
	link: any;
	icon: string;
	isRoot: boolean;
	typeId?: number;
	children?: TreeNode[];
	subAreas?: TreeNode[];
	subParent?: TreeNode;
	parent?: TreeNode;
}

export class TreeNode implements TreeNode {
	constructor(node: Node, type: NodeType) {
		this.name = node.name;
		this.id = node.id;
		this.link = ['/dashboard', node.id];
		this.icon = type.icon;
		this.isRoot = !node.active;
		this.typeId = type.id;
		this.children = [];
		this.subAreas = [];
	}
}
